// extracted by mini-css-extract-plugin
export var brand = "_2l-9";
export var compact = "_2l-6";
export var extraSmall = "_2l-7";
export var icon = "_2l-0";
export var large = "_2l-4";
export var light = "_2l-1";
export var medium = "_2l-5";
export var outline = "_2l-b";
export var primaryDark = "_2l-a";
export var primaryLight = "_2l-8";
export var primaryModern = "_2l-c";
export var success = "_2l-2";
export var successSolid = "_2l-3";